import React from "react";
import { InfoCard, InfoRow } from "@components/styles/dataDisplay";
import { CustomHeading } from "@pages/style";
import { ProfileDataContainer } from "@pages/ProfilePage/style";
import { CustomSkeleton, SkeletonContainer } from "./style";
import Skeleton from "react-loading-skeleton";

const CustomerInfoTabSkeleton: React.FC = () => {
  return (
    <InfoCard spacing="lg" border>
      <CustomHeading noMargin size="sm">
        <Skeleton width={256} height={20} />
      </CustomHeading>
      <ProfileDataContainer>
        <SkeletonContainer>
          <InfoRow>
            <Skeleton width={216} height={16} />
            <CustomSkeleton marginBottom={false} height={16} />
          </InfoRow>
          <InfoRow>
            <Skeleton width={216} height={16} />
            <CustomSkeleton marginBottom={false} height={16} />
          </InfoRow>
          <InfoRow>
            <Skeleton width={216} height={16} />
            <CustomSkeleton marginBottom={false} height={16} />
          </InfoRow>
        </SkeletonContainer>
      </ProfileDataContainer>
    </InfoCard>
  );
};

export default CustomerInfoTabSkeleton;
